module.exports = __webpack_public_path__ + "img/coinbankB05.cd1a8e56.jpg";